import _ from '@app/utils.js'

_.onElementArrive('.side-menu', menuEl => {
  const menuLinks = menuEl.querySelectorAll('a');
  const sections = [];
  menuLinks.forEach(link => {
    const section = document.getElementById(link.getAttribute('href').slice(1))
    if(section) {
      sections.push(section)
    }
  });
  menuLinks[0].classList.add('active');
  if(menuLinks.length === 0) {
    return
  }
  const sectionMap = {};
  menuLinks.forEach(link => {
    const id = link.getAttribute('href').slice(1);
    sectionMap[id] = link;
  });

  let lastScrollY = window.scrollY;

  function getScrollDirection() {
    const dir = window.scrollY > lastScrollY ? 'down' : 'up';
    lastScrollY = window.scrollY;
    return dir;
  }

  const observer = new IntersectionObserver(entries => {
    const direction = getScrollDirection();
    entries.forEach(entry => {
      const id = entry.target.id;
      if(entry.isIntersecting) {
        if (direction === 'down' && entry.boundingClientRect.top <= 0) {
          menuLinks.forEach(l => l.classList.remove('active'));
          sectionMap[id].classList.add('active');
        }
        if (direction === 'up' && entry.boundingClientRect.bottom >= 0 && entry.boundingClientRect.bottom <= window.innerHeight) {
          menuLinks.forEach(l => l.classList.remove('active'));
          sectionMap[id].classList.add('active');
        }
      }
    });
  }, {
    rootMargin: '0px 0px -100% 0px',
    threshold: 0,
  });
  sections.forEach(section => observer.observe(section));
})
